<svg
  id="svg"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  width="400"
  height="400"
  viewBox="0, 0, 400,400"
>
  <g id="svgg">
    <path
      id="path0"
      d="M187.891 33.334 C 69.518 43.139,-2.172 167.915,50.018 273.297 C 111.765 397.977,288.235 397.977,349.982 273.297 C 406.632 158.911,314.711 22.830,187.891 33.334 M206.696 118.666 C 210.510 120.399,214.291 124.763,215.515 128.846 C 216.766 133.023,216.766 216.977,215.515 221.154 C 210.948 236.396,189.052 236.396,184.485 221.154 C 183.234 216.977,183.234 133.023,184.485 128.846 C 186.485 122.171,193.091 117.222,200.000 117.222 C 201.934 117.222,204.947 117.872,206.696 118.666 M206.941 252.298 C 217.195 257.529,219.279 269.590,211.349 277.821 C 197.342 292.362,174.347 271.741,187.660 256.578 C 192.663 250.880,200.676 249.101,206.941 252.298 "
      fill-rule="evenodd"
    ></path>
  </g>
</svg>
